import { post } from "../http"

// 登录
export const login = params => post(`/web/wechat/bindMobile`, params)
// 验证码
export const smsCode = params => post(`/app/smsCode`, params)
// 支付提交
export const orderSave = params => post(`/web/wechat/order/save`, params)
// 支付签名
export const getPaySign = params => post(`/web/wechat/pay/paySign`, params)
// 获取oenId
export const getopenid = params => post(`/web/wechat/auth/openid`, params)
